import palette from "src/theme/palette";
import shadows from "src/theme/shadows";

export const LANGUAGES = {
  JSON: "json",
  JAVASCRIPT: "javascript"
};

export const DEFAULT_HEIGHT = "300px";

export const DEFAULT_OPTIONS = {
  autocompletion: true,
  lineNumbers: true,
  foldGutter: true,
  highlightActiveLine: true,
  highlightActiveLineGutter: true,
  lineWrapping: true
};

export const BASE_THEME = {
  "&": {
    border: `1px solid ${palette.system[200]}`,
    borderRadius: "8px",
    boxShadow: shadows[1]
  },
  "&.cm-focused": {
    outline: "none"
  },
  ".cm-gutters": {
    borderRadius: "8px 0 0 8px"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: shadows[4],
    padding: "8px",
  },

  ".cm-tooltip-autocomplete > ul > li": {
    margin: "2px 0"
  },

  ".cm-tooltip-autocomplete > ul > li[aria-selected]": {
    backgroundColor: "#e6f7ff",
    color: "#0050b3"
  },

  ".cm-completionDetail": {
    color: "#8c8c8c",
    fontStyle: "italic",
    fontSize: "0.85em",
  }
};
